import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Banner = ({
  color = "",
  text = "",
}) => {
  const theme = useTheme();

  const colorMap = {
    yellow: {
      backgroundColor: "#FFF4CC",
      textColor: "#8A6500",
      borderColor: "#F5C542",
    },
    red: {
      backgroundColor: "#FFE5E5",
      textColor: "#C62828",
      borderColor: "#EF5350",
    },
    green: {
      backgroundColor: "#E5F6EA",
      textColor: "#2E7D32",
      borderColor: "#4CAF50",
    },
  };

  const bannerColor = colorMap[color];

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "44px",
        px: 2,
        py: 1,
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        backgroundColor: bannerColor.backgroundColor,

        border: `1px solid ${bannerColor.borderColor}`,
        borderRadius: "8px",
      }}
    >
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: bannerColor.textColor,
          textAlign: "center",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default Banner;